import React from "react";
import { useSelector } from "react-redux";
import { Heading, SubHeading, Logo } from "./BlockParts/index";
export default function LogoBlock({ options, items, idx }) {
  const FontSettings = useSelector((state) => state.project?.fontStyle);
  return (
    <div
      key={idx}
      id={"block_" + idx}
      className="text-[18px] w-full flex flex-col justify-center overflow-hidden p-1 overlaytext"
    >
      <Heading options={options} fontStyle={FontSettings?.heading} idx={idx} />
      <SubHeading options={options} fontStyle={FontSettings?.subHeading} idx={idx} />
      <Logo options={options} items={items} idx={idx} />
    </div>
  );
}
